import React from 'react';
import StatusItem from './ui/StatusItem';
import { Status } from '../interfaces/Status';

type Props = {
  status: Status[]
}

export default function Historic ({ status }: Props): React.ReactElement {
  return (
    <div className="box">
      <p className="title is-level-3">Historique des statuts</p>
      <div className="timeline">
        { status.map((s: Status, i: number) =>
          <StatusItem key={ i }
            status={ s }
            state={ i < 1 ? 'active' : 'done' }/>)
        }
        { status.length < 1 && 
            <p className="text is-level-1 is-marginless">Nous n&apos;avons pas encore de statut enregistré sur votre dossier.</p>
        }
      </div>
    </div>
  );
}